export default function LocalePrice(currentLocale: string, price: any) {
    if (price === undefined) {
        return '--';
    }

    let formatter;
    const formatterParams = {
        currencyDisplay: 'code',
        minimumFractionDigits: 2,
    };
    if (currentLocale === 'fr_CA') {
        formatter = new Intl.NumberFormat('fr-CA', {
            style: 'currency',
            currency: 'CAD',
            ...formatterParams,
        });
        return formatter.format(price) + '$';
    } else if (currentLocale === 'en_CA') {
        formatter = new Intl.NumberFormat('en-CA', {
            style: 'decimal',
            currency: 'CAD',
            ...formatterParams,
        });
        return 'CAD $' + formatter.format(price);
    } else if (currentLocale === 'en_US') {
        formatter = new Intl.NumberFormat('en-US', {
            style: 'decimal',
            currency: 'USD',
            ...formatterParams,
        });
        return 'USD $' + formatter.format(price);
    }
}
